/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

class Col extends React.Component {
  static propTypes = {
    data: PropTypes.func.isRequired,
    style: PropTypes.shape(),
    span: PropTypes.number,
    className: PropTypes.string,
  };
  static defaultProps = {
    data: () => 'not text',
    style: {},
    className: '',
    span: null,
  };
  makeClassesByParams = props => {
    const resultClasses = {};
    if (props.span) {
      resultClasses[`ant-col-${props.span}`] = true;
    }
    return resultClasses;
  };
  render() {
    const { children, className, style, ...otherProps } = this.props;
    const classes = this.makeClassesByParams(otherProps);
    return (
      <div style={style} className={cn(className, classes)}>
        {children}
      </div>
    );
  }
}

export default Col;



// WEBPACK FOOTER //
// ./src/shared/components/AntdComponents/Grid/Col/Col.js